var map = {
	"./af.yml": "1831",
	"./bd.yml": "7e03",
	"./bf.yml": "46c7",
	"./bg.yml": "2aa5",
	"./cs.yml": "aa95",
	"./ct.yml": "e2d6",
	"./da.yml": "0770",
	"./en.yml": "eb57",
	"./hu.yml": "2020",
	"./ko.yml": "096c",
	"./lp.yml": "8889",
	"./lt.yml": "5306",
	"./lv.yml": "b911",
	"./ms.yml": "0abe",
	"./pl.yml": "958c",
	"./ro.yml": "cc8f",
	"./ru.yml": "01aa",
	"./sl.yml": "8878",
	"./sr.yml": "5d09",
	"./st.yml": "e365",
	"./sv.yml": "9d6a",
	"./ta.yml": "8535",
	"./th.yml": "e0ee",
	"./tr.yml": "a0db",
	"./xh.yml": "c64d",
	"./zh.yml": "1cbb",
	"./zu.yml": "afa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";